/**
 * App chrome layout — fluid widths from the Omen Transcend 16 design baseline.
 *
 * Baseline: Windows 150% on 2560×1600 → CSS viewport ≈ 1707px.
 * Fixed px at that size become % targets; clamp keeps a usable floor and today's max.
 */

/** CSS viewport the UI was tuned against (Omen @ 150%). */
export const DESIGN_VIEWPORT_W = 1707

/** Floor: enough for FILTERS + Reset + Save/Load without crush. */
export const FILTER_PANEL_MIN = 250
/** Cap at original Omen design width. */
export const FILTER_PANEL_MAX = 320
/** 320 / 1707 */
export const FILTER_PANEL_PCT = FILTER_PANEL_MAX / DESIGN_VIEWPORT_W

/** Floor: list card actions stay usable. */
export const RIGHT_PANEL_MIN = 300
/** Cap at original Omen design width. */
export const RIGHT_PANEL_MAX = 440
/** 440 / 1707 */
export const RIGHT_PANEL_PCT = RIGHT_PANEL_MAX / DESIGN_VIEWPORT_W

export const TIMELINE_APP_COL_MAX = 250
export const TIMELINE_APP_COL_MIN = 170
/** 250 / 1707 */
export const TIMELINE_APP_COL_PCT = TIMELINE_APP_COL_MAX / DESIGN_VIEWPORT_W

export const TIMELINE_SIDE_COL_MAX = 120
export const TIMELINE_SIDE_COL_MIN = 72
/** 120 / 1707 */
export const TIMELINE_SIDE_COL_PCT = TIMELINE_SIDE_COL_MAX / DESIGN_VIEWPORT_W

/** CSS clamp() for shell panels (% of the full-width app row ≈ viewport). */
export const FILTER_PANEL_WIDTH_CSS = `clamp(${FILTER_PANEL_MIN}px, ${(FILTER_PANEL_PCT * 100).toFixed(2)}%, ${FILTER_PANEL_MAX}px)`
export const RIGHT_PANEL_WIDTH_CSS = `clamp(${RIGHT_PANEL_MIN}px, ${(RIGHT_PANEL_PCT * 100).toFixed(2)}%, ${RIGHT_PANEL_MAX}px)`

/** Shared height for Filters / Timeline / Map / Details top chrome rows. */
export const PANEL_CHROME_HEADER_H = 40

/** Panel inner chrome: compact below these widths (px). */
export const FILTER_PANEL_COMFORT_W = 290
export const RIGHT_PANEL_COMFORT_W = 360

/** Pixel width from current viewport, capped to [min, max]. */
export function fluidPx(viewportW, pct, min, max) {
  if (!viewportW || viewportW <= 0) return max
  return Math.round(Math.min(max, Math.max(min, viewportW * pct)))
}
